<template>
  <div>
    <section>
        <b-card no-body class="shadow p-3 mb-5 bg-white rounded m-4">
          <div class="row">
            <div class="col-12 col-lg-2">
              <SidebarMenu
                :menus="menus"
                :selectedTab="selected"
                :expandedMenu="expandedMenu"
                @select="handleMenuSelect"
                @toggle-expand="toggleExpand"
              />
            </div>

            <div class="col-12 col-lg-10 mt-3 mt-lg-0">
              <keep-alive>
                <component :is="selected"></component>
              </keep-alive>
              <div class="text-center mt-5" v-if="selected === 'Profil'">
                <p><strong>{{ textMessage }}</strong></p>
                <b-button v-if="!showProductOptions && isFill" @click="showProductOptions = true" variant="primary">
                  Lihat Produk
                </b-button>

                <div v-if="showProductOptions" class="mt-3">
                  <b-button href="/list-produk-deposito" variant="success" class="mr-2">Deposito</b-button>
                  <b-button href="/list-produk-tabungan" variant="info">Tabungan</b-button>
                  <div class="mt-3">
                    <b-button variant="danger" @click="showProductOptions = false" style="background-color: transparent; border: transparent;">❌</b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
    </section>

    <!-- <Footer /> -->
  </div>
</template>

<script>
import SidebarMenu from "../components/pengajuan-saya/SidebarMenu.vue";
import Profil from "../components/pengajuan-saya/profil.vue";
import PengajuanFunding from "../components/pengajuan-saya/pengajuan.vue";
import Riwayat from "../components/pengajuan-saya/riwayat.vue";
import ChangePassword from "../components/pengajuan-saya/ChangePassword.vue";
import KycSign from "../components/pengajuan-saya/KycSign.vue";
import Pengajuan from "../api/pengajuan.js";

export default {
  name: "Dashboard",
  components: {
    SidebarMenu,
    Profil,
    PengajuanFunding,
    Riwayat,
    ChangePassword,
    KycSign,
  },
  data() {
    return {
      selected: "PengajuanFunding",
      isFill: false,
      textMessage: "",
      expandedMenu: "",
      showProductOptions: false,

      menus: [
        {
          label: "Produk",
          children: [
            {
              label: "Deposito",
              route: "/list-produk-deposito", // ⬅️ tambahkan ini
            },
            {
              label: "Tabungan",
              route: "/list-produk-tabungan", // ⬅️ dan ini
            },
          ],
        },
        {
          label: "Pengajuan Saya",
          component: "PengajuanFunding",
        },
        // {
        //   label: "Pengajuan Lending",
        //   component: "PengajuanLending",
        // },
        {
          label: "Riwayat",
          component: "Riwayat",
          // children: [
          //   {
          //     label: "Deposito/Tabungan",
          //     component: "Riwayat",
          //   },
          //   {
          //     label: "Pembiayaan",
          //     component: "RiwayatLending",
          //   },
          // ],
        },
        {
          label: "Profil",
          component: "Profil",
          children: [
            {
              label: "Detail Profil",
              component: "Profil",
            },
            {
              label: "Ganti Kata Sandi",
              component: "ChangePassword",
            },
            {
              label: "e-KYC & Sign",
              component: "KycSign",
            },
          ],
        },
      ],
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  watch: {
    "$route.query.q": {
      handler(newVal) {
        if (newVal === "Profil") this.selected = "Profil";
        else if (newVal === "KycSign") this.selected = "KycSign";
        else if (!newVal) this.selected = "PengajuanFunding";
      },
      immediate: true
    }
  },
  methods: {
    handleMenuSelect(menu) {
      if (menu.route) {
        this.$router.push(menu.route);
      } else if (menu.component) {
        this.selected = menu.component;
      }
    },
    toggleExpand(label) {
      if (this.expandedMenu === label) {
        this.expandedMenu = ""; 
      } else {
        this.expandedMenu = label; 
      }
    },
    loadData() {
      Pengajuan.isFunderCompleteProfile().then((res) => {
        if (res.data.meta.code === 200) {
          this.isFill = true;
          this.textMessage = "Kini anda dapat melakukan pengajuan produk!";
        } else {
          this.isFill = false;
          this.textMessage = "Silahkan lengkapi profil terlebih dahulu sebelum melakukan pengajuan produk!";
        }
      });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>


// WEBPACK FOOTER //
// src/public/pengajuan-saya.vue